export default "__VITE_ASSET__BXA5faL6__"